export default "https://cdn-static.gokick.com/assets/3bfc31eca91a3170017daa7173a338c2b0e2dfbc/images/diastolic-smaller.c0fadbcdc01bd506880e051915c30039.svg";